<script>
import { hasMediaHeader, getMediaType } from '@chatwoot/utils';
import { useAlert } from 'dashboard/composables';
import { mediaTypeForFile } from 'dashboard/helper/templateHelper';
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';
export default {
  components: {
    TemplatesPicker,
    WhatsAppTemplateReply,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    conversationId: {
      type: [Number, String],
      default: undefined,
    },
    // A file pasted/attached before the modal opened (e.g. while the reply box
    // was disabled outside the 24h window). When set, the modal auto-selects a
    // matching image template instead of making the agent hunt for one.
    pendingMediaFile: {
      type: File,
      default: null,
    },
    sendRenderedContent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
      candidateTemplates: null,
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
            templateName: this.selectedWaTemplate.name,
          })
        : this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
    },
  },
  watch: {
    show(isOpen) {
      if (isOpen && this.pendingMediaFile) {
        this.autoSuggestTemplate();
      } else if (!isOpen) {
        this.selectedWaTemplate = null;
        this.candidateTemplates = null;
      }
    },
  },
  methods: {
    autoSuggestTemplate() {
      const templates =
        this.$store.getters['inboxes/getFilteredWhatsAppTemplates'](
          this.inboxId
        ) || [];
      const mediaType = mediaTypeForFile(this.pendingMediaFile);
      const matches = templates.filter(
        tpl => hasMediaHeader(tpl) && getMediaType(tpl) === mediaType
      );

      if (matches.length === 1) {
        this.selectedWaTemplate = matches[0];
      } else if (matches.length > 1) {
        this.candidateTemplates = matches;
      } else {
        useAlert(
          this.$t('WHATSAPP_TEMPLATES.MODAL.NO_MEDIA_TEMPLATE', {
            type: mediaType,
          })
        );
      }
    },
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal v-model:show="localShow" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div class="row modal-content">
      <TemplatesPicker
        v-if="!selectedWaTemplate"
        :inbox-id="inboxId"
        :candidate-templates="candidateTemplates"
        @on-select="pickTemplate"
      />
      <WhatsAppTemplateReply
        v-else
        :template="selectedWaTemplate"
        :conversation-id="conversationId"
        :pending-media-file="pendingMediaFile"
        :send-rendered-content="sendRenderedContent"
        @reset-template="onResetTemplate"
        @send-message="onSendMessage"
      />
    </div>
  </woot-modal>
</template>

<style scoped>
.modal-content {
  padding: 1.5625rem 2rem;
}
</style>
